import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import { Button, Input, Link, Text } from '@beef/ui-kit';
import { useInput } from "../../../../../../../hooks/useInput";
import { validateEmail } from "../../../../../../../utils/validators";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var AGREEMENT = 'Нажимая «‎Отправить», ‎я даю свое согласие на обработку ';
var PERSONAL_DATA = 'персональных данных';
var INVALID_EMAIL = 'Неверный формат email';
var INVALID_NAME = 'Введите имя';
export var NewsSubscribeSection = function NewsSubscribeSection(_ref) {
  var size = _ref.size,
    subscribeData = _ref.subscribeData,
    personalDataLink = _ref.personalDataLink;
  var isNameValid = function isNameValid(name) {
    return name.length > 0;
  };
  var emailInput = useInput({
    initialState: '',
    errorText: INVALID_EMAIL,
    invalidHandler: validateEmail
  });
  var nameInput = useInput({
    initialState: '',
    errorText: INVALID_NAME,
    invalidHandler: isNameValid
  });
  var submitHandler = useCallback(function (event) {
    event.preventDefault();
    if (!emailInput.isValid) {
      emailInput.setErrorMessage(INVALID_EMAIL);
    }
    if (!nameInput.isValid) {
      nameInput.setErrorMessage(INVALID_NAME);
    }
    if (emailInput.isValid && nameInput.isValid) {
      subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.onClick(emailInput.value, nameInput.value);
    }
  }, [emailInput, nameInput, subscribeData]);
  return /*#__PURE__*/React.createElement("form", {
    className: cx('wrapper', size && "wrapper--".concat(size)),
    onSubmit: submitHandler
  }, /*#__PURE__*/React.createElement(Input, _extends({
    className: cx('input-wrapper'),
    label: "E-mail*",
    name: "e-mail",
    type: "email"
  }, emailInput)), /*#__PURE__*/React.createElement(Input, _extends({
    className: cx('input-wrapper'),
    label: "\u0418\u043C\u044F*",
    name: "name",
    type: "text"
  }, nameInput)), /*#__PURE__*/React.createElement("div", {
    className: cx('submit-wrapper')
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: size === 's',
    isLoading: !!(subscribeData !== null && subscribeData !== void 0 && subscribeData.isLoading),
    size: subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.size,
    type: "submit",
    variant: subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.variant
  }, subscribeData === null || subscribeData === void 0 ? void 0 : subscribeData.title)), personalDataLink && /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size6-r",
    tagType: "p"
  }, AGREEMENT, /*#__PURE__*/React.createElement("b", {
    className: cx('personal-data-link')
  }, /*#__PURE__*/React.createElement(Link, {
    href: personalDataLink,
    isNoUnderline: true,
    size: "size6-m",
    target: "_blank",
    variant: "light"
  }, PERSONAL_DATA))));
};